var exports = {
  "g": "restrictionShield__irrnPb",
};

module.exports = exports;
